import React from 'react'
import { BENEFIT_IMAGE } from '../../helpers/constants'
import ContactUs from '../ContactUs/Button'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-section='benefit'>
      <picture data-type='image'>
        <img
          width='650'
          height='652'
          itemProp='image'
          className='lazyload'
          data-src={BENEFIT_IMAGE}
          alt='benefit'
          role='presentation'
          data-type='image'
        />
      </picture>
      <div data-type='text-section'>
        <p data-type='subtitle'>With Saatchi Art Trade Services you’ll benefit from:</p>
        <div data-type='underline' />
        <ul>
          <li>Expert curation and advisory services</li>
          <li>Global selection of artists and resources</li>
          <li>Tiered trade discounts</li>
          <li>Discounts on large orders</li>
          <li>Custom sizes and new commissioned works</li>
          <li>Customer service with deep experience in handling trade orders</li>
          <li>World-class shipping experience </li>
        </ul>
        <ContactUs />
      </div>
    </div>
  )
}

export default Component